export const DESTINATIONS_HIGHLIGHTS = {
    'JUNGALA': 'Jungala',
    'PALACIO': 'Palacio Maya',
    'BEACHLAND': 'Beachland',
    'JOYA': 'Cirque du Soleil JOYÀ',
}
